import { InputText } from 'primereact/inputtext';
import { Dropdown, DropdownChangeParams } from 'primereact/dropdown';

import styles from './Filters.module.scss';
import { IFiltersProps } from './IFiltersProps';
import AddBrand from '../add/AddBrand';
import { useCookies } from 'react-cookie';

const Filters = ({
  brandTypesOptions,
  setBrandCodeFilter,
  setBrandDescriptionFilter,
  brandTypeFilter,
  setBrandTypeFilter,
  setShouldReload
}: IFiltersProps): JSX.Element => {
  
  const [cookies, setCookie] = useCookies([
    'brandsBrandType',
]); 
  return (
    <div className={styles.container}>
      <InputText
        className={styles.filter}
        placeholder="Brand code"
        onChange={e => {
          setBrandCodeFilter(e.target.value);
        }}
      />
      <InputText
        className={styles.filter}
        placeholder="Brand description"
        onChange={e => {
          setBrandDescriptionFilter(e.target.value);
        }}
      />
      <Dropdown
        style={{ width: '14%' }}
        className={styles.filter}
        placeholder="Brand Type"
        value={brandTypeFilter}
        options={brandTypesOptions}
        onChange={(e: DropdownChangeParams) => {
          setBrandTypeFilter(e.target.value);
          setCookie("brandsBrandType", e.value);
        }}
      />

      <AddBrand
        brandTypesOptions={brandTypesOptions}
        setShouldReload={setShouldReload}
      />
    </div>
  );
};

export default Filters;
